module.exports = __webpack_public_path__ + "static/img/3.8a9ce5d8.png";